import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckCertificateComponent } from './check-certificate/check-certificate.component';
import { RouterModule } from '@angular/router'


import { BuildingBlocksModule } from '@building-blocks/building-blocks.module'
import { GlobalServicesModule } from '@global-services/global-services.module'

import { FormsModule } from '@angular/forms';

export const PagesRoutes = [
	{ path: 'en', component: CheckCertificateComponent},
	{ path: 'es', component: CheckCertificateComponent},
	{ path: '', component: CheckCertificateComponent},
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(PagesRoutes),
    BuildingBlocksModule,
    GlobalServicesModule,
    RouterModule,
    FormsModule
  ],
  declarations: [CheckCertificateComponent]
})
export class PagesModule { }
